/**
 * Retrieves the user language from local storage.
 *
 * This function checks for a value stored under the key 'i18nextLng' in the browser's local storage and determines which language should be used.
 * If the value is either 'en' or starts with 'en-', then English will be returned. Similarly, if the value is 'pt' or starts with 'pt-', Portuguese will be returned.
 * If the value is neither of these, French ('fr') will be returned by default.
 *
 * @returns The language code (either 'en', 'pt', or 'fr').
 */
export const getLanguageFromLocalStorage = () => {
  const language = localStorage.getItem('i18nextLng');
  if (language === 'en' || language?.startsWith('en-')) {
    return 'en';
  }
  if (language === 'pt' || language?.startsWith('pt-')) {
    return 'pt';
  }
  if (language === 'fr' || language?.startsWith('fr-')) {
    return 'fr';
  }
  return 'pt';
};
